import Axios from "axios";
import React, { useEffect, useState } from "react";
import { GET_SINGLE_PAGE_URL } from "../../../../../configs";
import BackWithSearch from "../../../Elements/BackWithSearch";

const Popup = (props) => {
    console.log(JSON.stringify(props.match.params.page))

  const [getpages, setGetPages] = useState([]);
  const getSinglePages = async () => {
    Axios.post(`${GET_SINGLE_PAGE_URL}?slug=${props.match.params.page}`).then((response) => {
      if (response.status == 200) {
        setGetPages(response.data);
      }
    });
  };
  useEffect(() => {
    getSinglePages();
  }, []);
  console.log(getpages)
  return (
    <>
      <BackWithSearch
        boxshadow={true}
        has_title={true}
        title={getpages.name}
        disable_search={true}
        goto_accounts_page={true}
      />

      <div className="account-menu ml-15 my-3">
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "85%",
          margin: "auto",
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: getpages.body }}></div>
      </div>
    </>
  );
};

export default Popup;
